<template>
  <div class="dashboard_list">
    <v-list class="subscriptions_list pb-0" v-if="items">
      <div class="hidden-sm-and-down">
        <v-list-tile>
          <v-layout row px-2 align-center class="caption">
            <ListIcon></ListIcon>
            <v-flex xs7 class="font-weight-medium">
              Nazwa
            </v-flex>
            <v-flex xs4 class="font-weight-medium">
              Wykorzystywane miejsce
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-divider></v-divider>
      </div>
      <DashboardItem v-for="(item, i) in items" :key="i" :index="i" :item="item" />
      <div v-if="items && items.length === 0" class="px-4 py-4">
        <p class="mb-0 grey--text text--darken-1 subheading font-weight-bold">
          Brak elementów do wyświetlenia
        </p>
      </div>
    </v-list>
    <div v-if="!items">
      <div class="py-4 text-xs-center">
        <v-progress-circular
          :size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardItem from './DashboardItem.vue';
import ListIcon from './../common/ListIcon.vue';

export default {
  name: 'dashboard-list',
  props: ['items'],
  components: {
    DashboardItem,
    ListIcon,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>

</style>
